import {
  applicantStatusFormatter,
  applicantValidStatusFormatter,
  getLegalEntityName,
  localeFormatter,
} from '../../../utils/formatters';

export const applicantColumn = [
  {
    dataField: 'legal_entity_type',
    text: 'Тип заявителя',
    headerClassName: 'column-applicantType',
    formatter: a => localeFormatter('user.type', a),
  },
  {
    dataField: 'short_name',
    text: 'ФИО / Наименование',
    headerClassName: 'column-fullName',
    formatter: (_, item) => getLegalEntityName(item),
  },
  {
    dataField: 'inn',
    text: 'ИНН',
    headerClassName: 'column-inn',
  },
  {
    dataField: 'reg_type',
    text: 'Роль заявителя',
    headerClassName: 'column-role',
  },
  {
    dataField: 'phone',
    text: 'Телефон',
    headerClassName: 'column-phone',
  },
  {
    dataField: 'email',
    text: 'E-mail',
    headerClassName: 'column-email',
  },
  {
    dataField: 'status',
    text: 'Статус',
    headerClassName: 'column-status',
    formatter: applicantStatusFormatter,
  },
  {
    dataField: 'is_validation_result_array_not_empty',
    text: 'Соответствие',
    headerClassName: 'column-status',
    formatter: applicantValidStatusFormatter,
  },
];
